const s = {
  name: "Gramophone",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,20c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4C17.8,24,16,22.2,16,20z M20,18c-1.1,0-2,0.9-2,2
			c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C22,18.9,21.1,18,20,18z"/>
		<path class="st0" d="M20,5c3.8,0,7.2,1.4,9.9,3.7l0.5-0.5C30.2,7.7,30,7.1,30,6.5C30,4.6,31.6,3,33.5,3C35.4,3,37,4.6,37,6.5
			S35.4,10,33.5,10c-0.6,0-1.2-0.2-1.7-0.4l-0.5,0.5c2.3,2.6,3.7,6.1,3.7,9.9c0,8.3-6.7,15-15,15S5,28.3,5,20S11.7,5,20,5z M7,20
			c0,7.2,5.8,13,13,13s13-5.8,13-13c0-3.2-1.2-6.2-3.1-8.5l-5.2,5.2l-1.4-1.4l5.2-5.2C26.2,8.2,23.2,7,20,7C12.8,7,7,12.8,7,20z
			 M32,6.5C32,7.3,32.7,8,33.5,8S35,7.3,35,6.5S34.3,5,33.5,5S32,5.7,32,6.5z"/>
		<path class="st0" d="M36.3,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C35.7,33.8,36.3,34.3,36.3,35z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h34
			c0.6,0,1,0.4,1,1v34c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V3z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Gramophone
};
